import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { IconUIComponent } from '../icon/icon.component';
import { TOAST_ICON_BY_TYPE } from '../../../constants/toast.constants';
import { ToastType } from '../../../types/toast.type';

@Component({
  selector: 'fr8bot-ui-toast',
  imports: [IconUIComponent],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': '"toast--" + type()',
    '[attr.data-testid]': '"toast-" + type()',
  },
})
export class ToastUIComponent {
  readonly type = input<ToastType>('info');
  readonly title = input('');
  readonly message = input('');

  readonly dismiss = output<void>();

  protected readonly iconName = computed(() => TOAST_ICON_BY_TYPE[this.type()]);
}
